import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import dummyProducts from '../../../data/InventoryProductData';

// Unique categories from data
const categories = ['All', ...new Set(dummyProducts.map((p) => p.category))];

function SearchProduct() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedBarcode] = useState('');

  const filteredProducts = dummyProducts.filter((product) => {
    const matchesName = product.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesId = product.id.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesBarcode = product.barcode.toLowerCase().includes(selectedBarcode.toLowerCase());
    const matchesCategory = selectedCategory === 'All' || product.category === selectedCategory;
    return (matchesName || matchesId || matchesCategory || matchesBarcode) && matchesCategory;
  });

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold text-gray-800 mb-4">Inventory Browser</h1>

      <div className="flex flex-col sm:flex-row gap-4 mb-6 items-center">
        <input
          type="text"
          placeholder="Search by product Name or Id or Category"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full sm:w-1/2 px-4 py-2 border border-gray-300 rounded-lg"
        />

        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          className="w-full sm:w-1/3 px-4 py-2 border border-gray-300 rounded-lg"
        >
          {categories.map((cat) => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {filteredProducts.map((product) => (
          <Link
            to={`/inventory/product/${product.id}`}
            key={product.id}
            className="bg-white p-4 rounded-xl border shadow hover:shadow-md transition-shadow"
          >
            <h2 className="text-lg font-semibold text-slate-900">{product.name}</h2>
            <p className="text-sm text-gray-600">
              Category:
              {' '}
              {product.category}
            </p>
            {/*  barcode */}
            <p className="text-sm text-gray-600">
              Barcode:
              {' '}
              {product.barcode}
            </p>
            <p className="text-sm text-gray-600">
              Stock:
              {product.currentStock}
            </p>
            <p className="mt-2 text-sm text-blue-600">View details →</p>
          </Link>
        ))}
        {filteredProducts.length === 0 && (
          <div className="col-span-full text-center py-8">
            <p className="text-gray-500 text-lg">No products found</p>
            <p className="text-sm text-gray-400">Try different search terms or categories</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchProduct;
